import { Sprite } from "pixi.js";
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import SlotDefinition from "slotworks/model/slot-definition";
import Contract from "slotworks/utils/contracts/contract";
import * as TweenJS from "slotworks/utils/tween";

export default class LandPulseSymbolBehaviour extends AbstractSymbolBehaviour {
    public static ANIMATION_DURATION: number = 200;

    public static ZOOM_TO: number = 1.1;

    public behaviourName: string = "LandPulse";

    private clonedSymbol?: Sprite;
    private originalScale: number;
    private scale: number;

    public static(): void {
        super.static();
        this.cleanup();
        this.symbol.setVisible(true);
    }

    public land(): Contract<void> {
        return new Contract<void>((resolve) => {
            if (SlotDefinition.getSymbolDefinition(this.symbol.symbolId).bonusId) {
                this.createSprite();

                this.symbol.setVisible(false);

                this.originalScale = this.clonedSymbol.scale.x;
                this.scale = this.originalScale;

                this.update();

                const growTween = new TweenJS.Tween(this)
                    .to({ scale: this.originalScale * LandPulseSymbolBehaviour.ZOOM_TO }, LandPulseSymbolBehaviour.ANIMATION_DURATION / 2)
                    .onUpdate(() => this.update());

                const shrinkTween = new TweenJS.Tween(this)
                    .to({ scale: this.originalScale }, LandPulseSymbolBehaviour.ANIMATION_DURATION / 2)
                    .onUpdate(() => this.update());

                growTween.chain(shrinkTween);

                shrinkTween.onComplete(() => {
                    this.cleanup();
                    this.symbol.setVisible(true);
                    resolve();
                });

                growTween.start();
            }
        });
    }

    private createSprite() {
        this.cleanup();

        this.clonedSymbol = GraphicsManager.createSprite(this.symbol.symbolId);
        this.animationLayer.add(this.clonedSymbol);

        const transform = this.symbol.getTransform();
        const rect = this.symbol.getMatrixLayer().getPosition(`${this.symbol.symbolId}_land`);
        if (rect) {
            this.clonedSymbol.width = rect.width;
            this.clonedSymbol.height = rect.width;
        } else {
            this.clonedSymbol.width = transform.width;
            this.clonedSymbol.height = transform.height;
        }
        this.clonedSymbol.x = transform.x;
        this.clonedSymbol.y = transform.y;
    }

    private update() {
        if (this.clonedSymbol) {
            const transform = this.symbol.getTransform();
            let yOffset: number = 0;
            const rect = this.symbol.getMatrixLayer().getPosition(`${this.symbol.symbolId}_land`);
            if (rect) {
                yOffset = rect.y / 2;
            }
            this.clonedSymbol.scale.set(this.scale, this.scale);
            this.clonedSymbol.x = transform.x - ((this.clonedSymbol.width - transform.width) / 2);
            this.clonedSymbol.y = (transform.y + yOffset) - ((this.clonedSymbol.height - transform.height) / 2);
        }
    }

    private cleanup() {
        if (this.clonedSymbol) {
            this.animationLayer.remove(this.clonedSymbol);
            this.clonedSymbol.destroy();
            this.clonedSymbol = undefined;
        }
    }
}
